import { Card, Form, Info, Select, Title } from 'components/common'

export interface SalesStatusProps {
  loading?: boolean
  availableForSale?: boolean
}

export const SalesStatus = ({
  loading = false,
  availableForSale = true,
}: SalesStatusProps): JSX.Element => {
  return (
    <>
      <Card shadow loading={loading}>
        <Info
          title={
            '販売停止の場合一般ユーザー向けの予約画面に表示されなくなり予約することができなくなります。管理者は販売停止であっても予約を作成することができます。'
          }
        >
          <Title level={5} space="none">
            販売状況
          </Title>
        </Info>

        <div className="w-1/2 mt-4">
          <Form.Item
            label="販売状況"
            name="salesStatus"
            initialValue={availableForSale ? '販売中' : '販売停止'}
            rules={[{ required: true, message: '販売状況は必須です。' }]}
          >
            <Select>
              <Select.Option value={true}>販売中</Select.Option>
              <Select.Option value={false}>販売停止</Select.Option>
            </Select>
          </Form.Item>
        </div>
      </Card>
    </>
  )
}
